import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import React, { useCallback } from "react";

const TagSelectable = (props) => {
  const {
    tag,
    selectedTags = [],
    handleSelectTags = null,
    iconDSFR = "",
    size = "md",
    disabledTag = false,
    disabled = false,
  } = props;

  const selected = useCallback((s) => selectedTags.includes(s).toString(), [selectedTags]);

  let tagClassName = "fr-tag";
  if (size === "sm") {
    tagClassName += " fr-tag--sm";
  }
  if (iconDSFR) {
    tagClassName += ` fr-icon-${iconDSFR} fr-tag--icon-left`;
  }

  return (
    <>
      {disabledTag && selectedTags.includes(tag) && (
        <Box disabled sx={{ position: "absolute", top: 0, left: 0, bottom: 0, right: 0, zIndex: 1 }} />
      )}
      <button
        type="button"
        className={tagClassName}
        aria-pressed={selected(tag)}
        onClick={() => handleSelectTags(tag)}
        disabled={disabled}
      >
        {tag}
      </button>
    </>
  );
};

TagSelectable.propTypes = {
  tag: PropTypes.string.isRequired,
  selectedTags: PropTypes.arrayOf(PropTypes.string),
  handleSelectTags: PropTypes.func.isRequired,
  disabledTag: PropTypes.bool,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(["sm", "md"]),
  iconDSFR: PropTypes.string,
};

export default TagSelectable;
